import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiX } from "react-icons/si";

function Home2() {
  return (
    <section className="home-about-section" id="about">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col lg={7}>
            <h2 className="section-title" style={{ textAlign: "left", marginBottom: "0.5rem" }}>
              Let me <span>introduce</span> myself
            </h2>
            <p style={{ color: "var(--muted)", marginBottom: "1.5rem", fontSize: "0.95rem" }}>
              Cloud &amp; DevOps Engineer · AWS · FinOps &amp; Cloud Cost Optimization
            </p>
            <p className="home-about-body">
              I'm a <b className="purple">Cloud &amp; DevOps Engineer</b> with 1.9+ years of
              hands-on experience building, managing, and optimizing AWS infrastructure across
              production and internal environments — covering infrastructure provisioning,
              application deployment, automation, security, monitoring, and{" "}
              <b className="purple">FinOps &amp; cloud cost optimization</b>.
              <br /><br />
              My core focus areas:
              <ul>
                <li>
                  <b>FinOps &amp; Cost Visibility</b> — designed an application-level AWS cost
                  attribution &amp; tagging framework for environments with{" "}
                  <b className="purple">USD 1.2M+ monthly AWS spend</b>, plus right-sizing,
                  Savings Plans &amp; Reserved Instances.
                </li>
                <li>
                  <b>CI/CD &amp; DevSecOps Automation</b> — Jenkins, GitLab CI/CD, GitHub Actions
                  &amp; Azure DevOps pipelines with SonarQube, Trivy, and Gitleaks, including
                  automated failure handling, rollback, and alerting.
                </li>
                <li>
                  <b>Observability &amp; Proactive Monitoring</b> — centralized Prometheus &amp;
                  Grafana stack across Linux and Windows servers, plus CloudWatch and SNS-based
                  endpoint monitoring for early incident detection.
                </li>
                <li>
                  <b>Infrastructure as Code</b> — reusable Terraform &amp; Terragrunt modules with
                  organization-wide tagging standards baked into every provisioning workflow.
                </li>
              </ul>
              <br />
              Currently focused on scaling <b className="purple">FinOps practices</b> and{" "}
              <b className="purple">AI-assisted automation</b> to make cloud infrastructure more
              cost-transparent, secure, and self-service across every environment I manage.
            </p>
          </Col>

          {/* Right: key metrics bento */}
          <Col lg={4} className="mt-4 mt-lg-0">
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "0.75rem",
              }}
            >
              {[
                { v: "$1.2M+", l: "Monthly AWS Spend Managed", c: "#00d4aa" },
                { v: "AWS + Azure", l: "Multi-Cloud Experience", c: "#6c63ff" },
                { v: "24/7", l: "Production Monitoring", c: "#a855f7" },
                { v: "1.9+", l: "Years Experience", c: "#f59e0b" },
              ].map((s) => (
                <div
                  key={s.l}
                  style={{
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    borderRadius: "14px",
                    padding: "1.25rem 1rem",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "1.6rem", fontWeight: 800, color: s.c, lineHeight: 1 }}>
                    {s.v}
                  </div>
                  <div style={{ fontSize: "0.72rem", color: "var(--muted)", marginTop: 6, lineHeight: 1.4, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.4px" }}>
                    {s.l}
                  </div>
                </div>
              ))}
            </div>

            {/* Location & email */}
            <div
              style={{
                marginTop: "0.75rem",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "14px",
                padding: "1rem 1.1rem",
                fontSize: "0.83rem",
                color: "var(--muted)",
                lineHeight: 1.9,
              }}
            >
              <div>📍 Nagpur, India</div>
              <div>💼 Open to Cloud &amp; DevOps opportunities</div>
              <div>
                ✉️{" "}
                <a href="mailto:vedantkgaidhane@gmail.com" style={{ color: "var(--primary)", textDecoration: "none" }}>
                  vedantkgaidhane@gmail.com
                </a>
              </div>
            </div>
          </Col>
        </Row>

        {/* Social row */}
        <Row>
          <Col md={12} className="home-about-social" style={{ paddingTop: "2.5rem" }}>
            <h2 style={{ fontSize: "1.3rem", fontWeight: 700, color: "var(--white)", marginBottom: "0.4rem" }}>
              Find me on
            </h2>
            <p style={{ color: "var(--muted)", fontSize: "0.9rem", marginBottom: "1rem" }}>
              Let's connect — DevOps, cloud automation, or your next big idea.
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a href="https://github.com/Vedantgaidhane" target="_blank" rel="noreferrer" className="icon-colour home-social-icons" aria-label="GitHub">
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://x.com/VedantGaidhane?t=1pTPD2TV7g7Dsjb5xJq_rg&s=09" target="_blank" rel="noreferrer" className="icon-colour home-social-icons" aria-label="X (Twitter)">
                  <SiX />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.linkedin.com/in/vedant-gaidhane-4a4051208" target="_blank" rel="noreferrer" className="icon-colour home-social-icons" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a href="https://www.instagram.com/vedant_gaidhane?igsh=MXI5cWwxcW9qenlsMg==" target="_blank" rel="noreferrer" className="icon-colour home-social-icons" aria-label="Instagram">
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home2;
